<template>
  <div :id="componentId" class="spm1-partners" :style="{ backgroundImage: `url(${backgroundImage})` }">
    <div class="spm1-partner-list">
      <a
        v-for="(item, idx) in items"
        :key="idx"
        :class="['spm1-partner-item', { 'is-link': item.jumpType === 2 }]"
        href="javascript:;"
        @click.prevent="handleClick(item)"
      >
        <img class="spm1-partner-image" referrerpolicy="no-referrer" :src="item.pictureUrl" />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobilePartners',
  props: {
    componentId: {
      type: String,
      default: 'sp_one_module_14'
    }
  },
  data() {
    return {
      backgroundImage: require('../../../special/SpecialOne/assets/img/bottom_bg.png'),
      items: [
        {
          pictureUrl: require('../../../special/SpecialOne/assets/img/partners_short.png'),
          pictureType: 1,
          jumpType: 1,
          linkAddress: ''
        },
        {
          pictureUrl: require('../../../special/SpecialOne/assets/img/partners_long.png'),
          pictureType: 2,
          jumpType: 2,
          linkAddress: 'https://www.example.com/partners'
        }
      ]
    }
  },
  methods: {
    handleClick(item) {
      if (item.jumpType !== 2 || !item.linkAddress) return
      window.open(item.linkAddress, '_blank')
    }
  }
}
</script>

<style scoped>
.spm1-partners {
  width: 100%;
  padding: 16px 12px;
  box-sizing: border-box;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.spm1-partner-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.spm1-partner-item {
  display: block;
  width: 100%;
  border-radius: 6px;
  overflow: hidden;
}

.spm1-partner-item.is-link {
  cursor: pointer;
}

.spm1-partner-item.is-link:active {
  opacity: 0.9;
}

.spm1-partner-image {
  width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
}
</style>
